import React, { Component } from 'react'
import { connect } from 'react-redux'

class App extends Component {
	render() {
		return (
            <div>
                <h3>E-Compras</h3>
            </div>
		)
	}
}

function mapStateToProps(state) {
    return {
    }
}

function mapDispatchToProps(dispatch) {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(App)


// WEBPACK FOOTER //
// ./src/containers/App.jsx